import { QueryClient } from '@tanstack/react-query';

/**
 * Jedna instancja `QueryClient` dla całej aplikacji (§16.2: React Query jako warstwa
 * pobierania danych). Fabryka (nie moduł-singleton) — testy tworzą własną, izolowaną instancję
 * zamiast dzielić stan zapytań między przypadkami testowymi.
 *
 * `retry: 1` zamiast domyślnych trzech prób — sesja/uprawnienia są sprawdzane synchronicznie
 * z nawigacją (`router.tsx`, `beforeLoad`), więc długie ponawianie tylko opóźnia przekierowanie
 * na `/login` przy realnym braku sesji. `refetchOnWindowFocus: false` — dane sesji/nawigacji nie
 * muszą się odświeżać przy każdym powrocie do karty; unika też migotania (§7.2).
 *
 * WAŻNE (§16.2 „nie przechowywać w nim sekretów"): żadne zapytanie w tej aplikacji nie
 * przechowuje tokenu sesji — cookie sesji jest `HttpOnly` i klient nigdy go nie widzi
 * (patrz `features/auth/session.ts`). Query Client trzyma wyłącznie dane już bezpieczne do
 * pokazania w UI (e-mail, role, identyfikatory zasobów).
 */
export function createAppQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        refetchOnWindowFocus: false,
        staleTime: 30_000,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
